import {MOON_50, SIENNA_600} from '@wandb/weave/common/css/globals.styles';
import {TextField} from '@wandb/weave/components/Form/TextField';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner, BannerTextWrapper} from '../Banner';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: ${MOON_50};
`;
Panel.displayName = 'S.Panel';

export const OptionsPanel = styled.div`
  display: flex;
  width: 100%;
  margin: 24px 0px;
  align-items: center;
`;
OptionsPanel.displayName = 'S.OptionsPanel';

export const SelectPanel = styled.div`
  width: 300px;
  margin-right: 8px;
`;
SelectPanel.displayName = 'S.SelectPanel';

export const StyledTextField = styled(TextField)`
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
StyledTextField.displayName = 'S.StyledTextField';

export const BannerWithMargin = styled(Banner)`
  margin-top: 40px;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';

export const BannerLink = styled.span`
  cursor: pointer;
  font-weight: 600;
  color: ${SIENNA_600};
`;
BannerLink.displayName = 'S.BannerLink';

export const BannerTextWithPadding = styled(BannerTextWrapper)`
  padding: 0px 16px;
`;
BannerTextWithPadding.displayName = 'S.BannerTextWithPadding';
